export default (theme) => ({
  container: {
    padding: 5,
  },
  flex: {
    width: `${100 / 7}%`,
  },
});
